const footerLinks = [
  {
    title: '内容版块',
    links: [
      { label: '焦点专题', href: '#carousel' },
      { label: '黑料热榜', href: '#ranking' },
      { label: '最新快讯', href: '#updates' },
      { label: '专题索引', href: '#index' },
      { label: '精选视频', href: '#media' },
      { label: '图文资讯', href: '#cards' },
    ],
  },
  {
    title: '平台信息',
    links: [
      { label: '关于我们', href: '#about' },
      { label: '平台特色', href: '#features' },
      { label: '常见问题', href: '#faq' },
      { label: '热门话题', href: '#topics' },
      { label: '投稿爆料', href: '#contact' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer no-underline">
                <span className="text-2xl font-black tracking-tight">
                  <span className="text-accent-400">91</span>
                  <span className="text-white">黑料网</span>
                </span>
              </a>
              <p className="text-foreground-400 text-xs leading-relaxed mb-4">
                91黑料网 - 最新黑料视频合集与在线观看平台。
                每日更新最新黑料短视频，涵盖娱乐圈、网红圈、
                体育圈、科技圈等多个领域，为您提供一站式的
                黑料视频在线播放体验。
              </p>
            </div>

            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-bold text-white mb-4">{col.title}</h4>
                {col.links.length > 0 ? (
                  <ul className="space-y-2.5">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          className="text-foreground-400 hover:text-accent-400 text-xs transition-colors cursor-pointer no-underline"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-foreground-500 text-xs">敬请期待</p>
                )}
              </div>
            ))}
          </div>

          <div className="border-t border-foreground-800 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; 2020-2026 91黑料网 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
              </p>
              <div className="flex items-center gap-4">
                <a href="#hero" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer no-underline">
                  <i className="ri-arrow-up-line" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}